import { DiffSyncSchema } from "@megaron/diff-sync-contracts";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const pricingRuleCustomerFieldsSerializer = Serializers.object({
  priceList: Serializers.string.nullable(),
  defaultDiscount: Serializers.decimal.nullable(),
  pricingNotes: Serializers.string,
  pricingModifiedAt: Serializers.datetime.nullable(),
  pricingModifiedBy: Serializers.string.nullable(),
});

export type PricingRuleCustomerFields = SerializerValue<typeof pricingRuleCustomerFieldsSerializer>;

export const pricingRuleSheetRowSerializer = Serializers.object({
  priceList: Serializers.string,
  customerId: uuidSerializer.nullable({ emptyStrAsNull: true }),
  customerName: Serializers.string.nullable({ emptyStrAsNull: true }),
  defaultDiscount: Serializers.decimal,
  notes: Serializers.string,
});

export type PricingRuleSheetRow = SerializerValue<typeof pricingRuleSheetRowSerializer>;

export const legacyMegaraxPricingRuleSerializer = Serializers.object({
  customerId: uuidSerializer,
  customerName: Serializers.string.nullable({ emptyStrAsNull: true }),
  priceList: Serializers.string.nullable({ emptyStrAsNull: true }),
  defaultDiscount: Serializers.decimal,
  notes: Serializers.string,
  modifiedAt: Serializers.datetime,
  modifiedBy: Serializers.string.nullable({ emptyStrAsNull: true }),
});

export type LegacyMegaraxPricingRule = SerializerValue<typeof legacyMegaraxPricingRuleSerializer>;

export const crmDiffSyncSchema = DiffSyncSchema({
  sheetsPricingRule: pricingRuleSheetRowSerializer.partial(),
  legacyMegaraxPricingRule: legacyMegaraxPricingRuleSerializer.partial(),
});

export type CrmDiffSyncChannel = keyof typeof crmDiffSyncSchema & string;
